import { ApiOutlined, ArrowLeftOutlined } from '@ant-design/icons';

// Split a trailing parenthetical off a title — "iCIMS Job (Test clone of Peraton)" renders the
// parenthetical part lighter (regular weight, tertiary ink) per the design.
function splitParenthetical(title) {
	if (typeof title !== 'string') return { main: title, paren: null };
	const m = /^(.*?)\s*(\([^)]*\))\s*$/.exec(title);
	return m ? { main: m[1], paren: ` ${m[2]}` } : { main: title, paren: null };
}

// The editorial page head shared by the list, wizard and editor views: a crumb row (tinted chip +
// back link) and an H1 row with an optional mono subtitle / description and a right-hand slot
// (Enabled switch, Dry-run|Live toggle, primary action, …).
export default function ConsoleHeader({
	onBack,
	backLabel = 'All integrations',
	title,
	subtitle,
	description,
	rightSlot,
}) {
	const { main, paren } = splitParenthetical(title);
	return (
		<>
			<div className="ei-crumbrow">
				<span className="ei-crumb-chip" aria-hidden>
					<ApiOutlined />
				</span>
				{onBack ? (
					<button type="button" className="ei-crumb" onClick={onBack}>
						<ArrowLeftOutlined /> {backLabel}
					</button>
				) : null}
			</div>
			<div className="ei-pagehead">
				<div className="ei-pagehead-txt">
					<h1 className="ei-h1">
						{main}
						{paren ? <span className="ei-h1-paren">{paren}</span> : null}
					</h1>
					{subtitle ? <div className="ei-h1-sub">{subtitle}</div> : null}
					{description ? <p className="ei-h1-desc">{description}</p> : null}
				</div>
				{rightSlot ? <div className="ei-headright">{rightSlot}</div> : null}
			</div>
		</>
	);
}
